import { BaseTabs } from 'app/components/common/BaseTabs'
import { IActivityEvent } from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { TeamRegisteredByStatusLayout } from './TeamRegisteredByStatus'
import { useTeamRegisteredByStatusLayout } from './hook'
import { useState } from 'react'
import { LabelComponent, TabKeysEnum } from 'app/containers/EventManagement/RegisterActivity/components'
import { RegisterTeamActivityStatus } from 'app/api/event/model'

export const ApproveTeamLayout = ({ item }: { item: IActivityEvent }) => {
  const [tab, setTab] = useState(TabKeysEnum.OPEN)

  const waitingHook = useTeamRegisteredByStatusLayout({
    status: RegisterTeamActivityStatus.WAITING,
    actionId: item?.id,
  })

  const acceptedHook = useTeamRegisteredByStatusLayout({
    status: RegisterTeamActivityStatus.ACCEPTED,
    actionId: item?.id,
  })

  const rejectedHook = useTeamRegisteredByStatusLayout({
    status: RegisterTeamActivityStatus.REJECTED,
    actionId: item?.id,
  })

  return (
    <BaseTabs
      onChange={ta => setTab(ta as TabKeysEnum)}
      items={[
        {
          key: TabKeysEnum.WAITING,
          label: (
            <LabelComponent
              tabActive={tab}
              tabKey={TabKeysEnum.WAITING}
              label="Chờ phê duyệt"
              count={waitingHook?.data?.length}
            />
          ),
          children: (
            <TeamRegisteredByStatusLayout
              status={RegisterTeamActivityStatus.WAITING}
              listTeam={item?.teams ?? []}
              locations={item?.locations ?? []}
              data={waitingHook.data ?? []}
              isLoading={waitingHook.isLoading}
            />
          ),
        },
        {
          key: TabKeysEnum.ACCEPTED,
          label: (
            <LabelComponent
              tabActive={tab}
              tabKey={TabKeysEnum.ACCEPTED}
              label="Đã phê duyệt"
              count={acceptedHook?.data?.length}
            />
          ),
          children: (
            <TeamRegisteredByStatusLayout
              status={RegisterTeamActivityStatus.ACCEPTED}
              data={acceptedHook.data ?? []}
              isLoading={acceptedHook.isLoading}
            />
          ),
        },
        {
          key: TabKeysEnum.REJECTED,
          label: (
            <LabelComponent
              tabActive={tab}
              tabKey={TabKeysEnum.REJECTED}
              label="Đã từ chối"
              count={rejectedHook?.data?.length}
            />
          ),
          children: (
            <TeamRegisteredByStatusLayout
              status={RegisterTeamActivityStatus.REJECTED}
              data={rejectedHook.data ?? []}
              isLoading={rejectedHook.isLoading}
            />
          ),
        },
      ]}
    />
  )
}
